import { render, staticRenderFns } from "./topUp.vue?vue&type=template&id=4da58252&scoped=true"
import script from "./topUp.vue?vue&type=script&lang=js"
export * from "./topUp.vue?vue&type=script&lang=js"
import style0 from "./topUp.vue?vue&type=style&index=0&id=4da58252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da58252",
  null
  
)

export default component.exports